import { render, staticRenderFns } from "./DIVEMetadataEdit.vue?vue&type=template&id=48eaf533&scoped=true"
import script from "./DIVEMetadataEdit.vue?vue&type=script&lang=ts"
export * from "./DIVEMetadataEdit.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48eaf533",
  null
  
)

export default component.exports